import { useEffect, useState } from 'react';

export type Density = 'comfortable' | 'compact';

const KEY = 't212:density';

function read(): Density {
  if (typeof window === 'undefined') return 'comfortable';
  return (localStorage.getItem(KEY) as Density | null) ?? 'comfortable';
}

function apply(d: Density) {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.density = d;
}

export function useDensity(): [Density, (d: Density) => void, () => void] {
  const [density, setDensityState] = useState<Density>(() => read());

  useEffect(() => {
    apply(density);
    localStorage.setItem(KEY, density);
  }, [density]);

  const setDensity = (d: Density) => setDensityState(d);
  const toggle = () => setDensityState((d) => (d === 'comfortable' ? 'compact' : 'comfortable'));

  return [density, setDensity, toggle];
}
